import React, { Component, Fragment } from "react";

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import { required, length } from "../../util/validators";
import Loader from "../../components/Loader/Loader";
import Newloader from "../../components/Loader/NewLoader/NewLoader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import SizeForm from "../../components/Variant/SizeForm/SizeForm";
import Paginator from '../../components/Paginator/Paginator';

import "./Size.css";

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 1 })],
  },
  sort: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required],
  },
  categoryCode: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
};

class Size extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sizes: [],
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      totalSizes: 0,
      perPage: 1,
      sizePage: 1,
      sizesLoading: true,
    };
  }

   componentDidMount() {
    this.loadSizes(1);
  }

  
  toggleClass() {
    this.setState({
      active: this.state.active ? false : true,
      isEditing: false,
      editingData: {}
    });
  }

  onDeleteSizeHandler = (data) => {
    const Index = this.state.sizes.findIndex((p) => p.id === data.code);

    this.setState({
      code: data.code,
      showMessage: true,
      label: data.label,
      title: this.state.sizes[Index].title,
    });
  };

  onEditSizeHandler = (data) => {
    const Index = this.state.sizes.findIndex((p) => p.id === data.code);  
    
    this.setState({
      active: true,
      isEditing: true,
      editingData: this.state.sizes[Index]
    });

    // this.props.onEditHandler.bind(this, {
    //   code: this.state.code,
    //   label: this.state.label,
    // });
  };

  onCancelSizeHandler = () => {
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });
  };
  onDeleteSizeTypeDicisionHandler = () => {
    this.props.onDeleteDataHandler({
      code: this.state.code,
      label: this.state.label,
    });
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });    
  };


  onEditHandler = () => {
    this.setState({
      isEditing: true,
    });
  };
  onDeleteHandler = (data) => {
      const graphqlQuery = {
        query: `
        mutation {
          deleteSize(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("خطا در حذف سایز!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.sizes];
            const postIndex = prevState.sizes.findIndex(
              (p) => p.id === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              sizes: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });        
  };

  loadSizes = (sizePage) => {
    if (sizePage) {
      this.setState({ sizesLoading: true, sizes: [] });
    }

    const graphqlQuery = {
        query: `
          query FetchSizes($page: Int, $perPage: Int) {
            allSizes(page: $page, perPage: $perPage) {
              Sizes {
                id
                title
                sort
                isActive
              }
              totalSizes
            }
          }
        `,
      variables: {
        page: sizePage,
        perPage: this.state.perPage
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            sizes: resData.data.allSizes.Sizes,
            totalSizes: resData.data.allSizes.totalSizes,
            sizesLoading: false,
            sizePage: sizePage 
        });
           
      })
      .catch(this.catchError);
  };

  acceptSizeChangeHandler = (postData) => {
    this.setState({
      editLoading: true,
    });
    
    
    let graphqlQuery;
    if (postData.editingCode !== 0) {
        graphqlQuery = {
          query: `
            mutation updatedSize($code: Int!, $categoryCode: Int!, $title: String!, $sort: Int!, $isActive: Boolean!) {
              updateSize(code: $code, sizeInput: {categoryCode: $categoryCode, title: $title, sort: $sort, isActive: $isActive}) {
                id
                title
                sort
                isActive
              }
            }
          `,
          variables: {
            code: parseInt(postData.editingCode),
            categoryCode: postData.categoryCode,
            title: postData.title,
            sort: parseInt(postData.sort),
            isActive: true,
          },
        };
    } else {
        graphqlQuery = {
          query: `
            mutation createNewSize($categoryCode: Int!, $title: String!, $sort: Int!, $isActive: Boolean!) {
              createSize(sizeInput: {categoryCode: $categoryCode, title: $title, sort: $sort, isActive: $isActive}) {
                id
                title
                sort
                isActive
              }
            }
          `,
          variables: {
            categoryCode: postData.categoryCode,
            title: postData.title,
            sort: parseInt(postData.sort),
            isActive: true,
          },
        };     
    }     

    return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      body: JSON.stringify(graphqlQuery),
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "createSize";
        if (postData.editingCode !== 0) {
          resDataField = "updateSize";          
        }

        var post = {
          id: resData.data[resDataField].id,
          title: resData.data[resDataField].title,
          sort: resData.data[resDataField].sort,
          isActive: resData.data[resDataField].isActive,
        };

        this.setState((prevState) => {
          let updatedTotalSizes = prevState.totalSizes;
          let updatedPosts = [...prevState.sizes];
          if (postData.editingCode !== 0) {
            const postIndex = prevState.sizes.findIndex(
              (p) => p.id == post.id
            );
            updatedPosts[postIndex] = post;
          } else {
            updatedTotalSizes++;
            if (prevState.sizes.length >= prevState.perPage) {
              updatedPosts.pop();
            }
            updatedPosts.unshift(post);
          }

          return {
            active: false,
            sizes: updatedPosts,
            totalSizes: updatedTotalSizes
          };          
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editSize: false,
          editLoading: false,
          error: err,
        });
      });
  };

  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelSizeHandler}
          message={
            "آیا می‌خواهید سایز " +
            this.state.title +
            ' را حذف کنید؟'
          }
          onCancelModal={this.onCancelSizeHandler}
          onAcceptModal={this.onDeleteSizeTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="درج سایز"
              headerDescription="اطلاعات سایز کالاها را در این صفحه وارد کنید"
            />
            <Card> 
                <span className="mn-promo-report__header-card-bold-title">جستجو و فیلتر</span>
                <div className="mn-card__body">
                    <form className="mn-ui-form" method="POST" id="searchForm" onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-ui-form__row mn-ui-form__row_padding">
                            <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                                <div className="c-ui-paginators">
                                    <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                                        <label className="uk-form-label uk-flex uk-flex-between">جستجو:</label>
                                        <div className="field-wrapper ui-select ui-select__container">
                                            <div className="mn-ui-input">
                                                <input type="text" name="brand-search" className="mn-ui-input__field mn-ui-input__field--order" id="brand-search" placeholder="عبارت مورد نظرتان را وارد کنید..."/>
                                            </div>                                        
                                        </div>
                                    </div>
                                    <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                        <button className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active mn-search-btn--search-form mn-search_padding" id="submitButton">
                                            <span className="mn-seach__btn">جستجو</span>
                                        </button>
                                        <button type="button" className="mn-content-categories__search-reset" id="resetButton"></button>
                                    </div>
                                </div>
                                <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                    <button onClick={this.toggleClass.bind(this)} type="button" className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding" id="submitButton">
                                        <span className="mn-seach__btn">ایجاد سایز جدید</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div
                      className={[
                        "mn-grid__row mn-brand__gap",
                        `${!this.state.active ? "uk-hidden" : ""}`,
                      ].join(" ")}
                    >
                      <SizeForm
                        toggleClass={this.toggleClass.bind(this)}
                        onAcceptModal={this.acceptSizeChangeHandler.bind( this )}
                        isEditing={this.state.isEditing}
                        editingData={this.state.editingData}
                        userId={this.props.userId}
                        token={this.props.token}
                      />
                    </div>             

                </div>
            </Card>
            <Card>
                <div className="c-card__wrapper">
                    <div className="mn-card__header mn-card__header--table">
                        <Paginator
                          onNext={this.loadSizes.bind(this)}
                          lastPage={Math.ceil(this.state.totalSizes / this.state.perPage)}
                          totalSizes={this.state.totalSizes}
                          currentPage={this.state.sizePage}
                        />
                    </div>
                    <div className={[ "c-card__body c-ui-table__wrapper", this.state.sizesLoading ? "c-content-loading" : "" ].join(" ")}>
                        <table className="c-ui-table   js-search-table " data-sort-column="" data-sort-order="asc" data-search-url="/commissions/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                            <thead>
                                <tr className="c-ui-table__row">
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="js-search-table-column">ردیف</span>
                                    </th>
                                
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">نام سایز</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                    <span className="table-header-searchable">ترتیب سایز</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">ویرایش سایز</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">حذف سایز</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.sizes !== [] && (
                                <Fragment>
                                    {this.state.sizes.map((data, index) => (
                                    <tr>
                                        <td className="c-ui-table__cell c-ui-table__cell--smaller">
                                        {index + 1}
                                        </td>
                                        <td className="c-ui-table__cell">{data.title}</td>
                                        <td className="c-ui-table__cell">{data.sort}</td>
                                        
                                        <td className="c-ui-table__cell ">
                                          <span
                                              className="mn-link-row__status-ui edit"
                                              onClick={this.onEditSizeHandler.bind(this, {
                                              code: data.id,
                                              })}
                                          >
                                              {"ویرایش"}
                                              <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                          </span>
                                        </td>
                                        <td className="c-ui-table__cell">
                                          <span
                                              className="mn-link-row__status-ui delete"
                                              onClick={this.onDeleteHandler.bind(this, {
                                              code: data.id,
                                              })}
                                          >
                                              {"حذف"}
                                              <i className="fa fa-trash-o" aria-hidden="true"></i>
                                          </span>
                                        </td>
                                    </tr>
                                    ))}
                                </Fragment>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="c-card__footer">
                        <Paginator
                          onNext={this.loadSizes.bind(this)}
                          lastPage={Math.ceil(this.state.totalSizes / this.state.perPage)}
                          totalSizes={this.state.totalSizes}
                          currentPage={this.state.sizePage}
                        />
                    </div>
                    {this.state.sizesLoading && (
                      <div className="c-content-loader">
                        <Newloader/>
                      </div>
                    )} 
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default Size;

